import { useEffect } from "react";
import Lenis from "lenis";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import PathFinder from "@/components/landing/PathFinder";
import Marquee from "@/components/landing/Marquee";
import Manifesto from "@/components/landing/Manifesto";
import Audiences from "@/components/landing/Audiences";
import Partner from "@/components/landing/Partner";
import HowItWorks from "@/components/landing/HowItWorks";
import Testimonials from "@/components/landing/Testimonials";
import VideoWall from "@/components/landing/VideoWall";
import Plans from "@/components/landing/Plans";
import LeadForm from "@/components/landing/LeadForm";
import AboutJohn from "@/components/landing/AboutJohn";
import SavingsCalculator from "@/components/landing/SavingsCalculator";
import Footer from "@/components/landing/Footer";
import StickyPathBar from "@/components/landing/StickyPathBar";

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export default function LandingPage() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);

  useEffect(() => {
    if (!window.location.hash) return;
    const t = setTimeout(() => scrollToId(window.location.hash), 500);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const src = new URLSearchParams(window.location.search).get("src");
    const referrer = src ? `src:${src}` : document.referrer;
    window.__track = (event) =>
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ path: window.location.pathname, referrer, event }),
      }).catch(() => {});
    if (sessionStorage.getItem("mll_tracked")) return;
    sessionStorage.setItem("mll_tracked", "1");
    window.__track("visit");
  }, []);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > document.body.scrollHeight * 0.5 && !sessionStorage.getItem("mll_scrolled")) {
        sessionStorage.setItem("mll_scrolled", "1");
        window.__track?.("scroll_50");
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <main data-testid="landing-page" className="overflow-x-clip">
      <Nav />
      <Hero />
      <PathFinder />
      <Marquee />
      <Manifesto />
      <SavingsCalculator />
      <Audiences />
      <Partner />
      <HowItWorks />
      <Plans />
      <Testimonials />
      <VideoWall />
      <AboutJohn />
      <LeadForm />
      <Footer />
      <StickyPathBar />
    </main>
  );
}
